import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Product } from 'src/resources'
import ProductBox from 'src/components/containers/configurator/ProductBox'
import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import Checkmark from 'src/components/atoms/input/Checkmark'
import { StoreProps } from 'src/stores'
import CustomModal from 'src/components/containers/CustomModal'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import { media } from 'src/utils.js'
import ReactHtmlParser from 'react-html-parser';


interface Props extends StoreProps {
  product: Product
  disabled?: boolean
  horizontal?: boolean
  gridArea?: any
  idLabel?: any
}

interface State {
  modal: boolean
  isChecked: boolean
}

@inject('confStore')
@observer
export default class ProductCard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { product } = this.props
    this.state = {
      modal: false,
      isChecked: this.hasProduct(product.uuid)
    }
  }

  hasProduct = (uuid) => {
    const { confStore } = this.props
    let hasProduct = false
    if (confStore.getOffer.products) {
      toJS(confStore.getOffer.products).forEach((product) => {
        if (product.uuid === uuid) hasProduct = true
      })
    }
    return hasProduct
  }

  handleClick = () => {
    const { confStore, product } = this.props
    const { isChecked } = this.state
    const checkmark = !isChecked
    confStore.toggleProduct(product, 1, true)
    this.setState({ isChecked: checkmark })
  }

  render() {
    const { disabled, horizontal, product, gridArea, idLabel } = this.props
    const { modal } = this.state

    const price = product.prices[0].amount / 100
    const productBox = (
      <ProductBox gridArea={gridArea} disabled={disabled}>
        <ProductImage horizontal={horizontal} img={product.photos[0]} />
        <ProductDataContainer horizontal={horizontal}>
          <PriceHeadline service={product.name} price={price} />
          <p>{product.shortDescription}</p>
          <MoreInfo onClick={() => this.setState({ modal: true })} />
          {price > 0 && (
            <Checkmark
              onClick={() => this.handleClick()}
              checked={this.hasProduct(product.uuid)}
              id = {idLabel}
              >
              <p>Auswählen</p>
            </Checkmark>
          )}
        </ProductDataContainer>
      </ProductBox>
    )

    return (
      <>
        <CustomModal
          title={product.name}
          onClose={() => this.setState({ modal: false })}
          open={modal}>
          <p>{product.shortDescription}</p>
          <div className='product-long-desc' style={{ textAlign: 'left' }}>
            {ReactHtmlParser(product.longDescription)}
          </div>
        </CustomModal>
        {productBox}
      </>
    )
  }
}

const ProductImage = styled.div`
  width: ${(props) => (props.horizontal ? 'calc(50% - 7.5px)' : '100%')};
  height: ${(props) => (props.horizontal ? '100%' : '50%')};
  min-height: ${(props) => (props.horizontal ? '230px' : '180px')};
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${(props) => props.img});
  background-position: ${(props) => (props.horizontal ? 'center' : 'left')};

  ${media.desktop`
    width: calc(50% - 7.5px);
    height: 100%;
  `}
  ${media.tablet`
    width: 100%;
    height: 50%;
  `}
`

const ProductDataContainer = styled.div`
  position: relative;
  height: ${(props) => (props.horizontal ? '100%' : '50%')};
  width: ${(props) => (props.horizontal ? 'calc(50% + 7.5px)' : '100%')};
  min-height: ${(props) => (props.horizontal ? '230px' : '200px')};
  padding: 15px;
  padding-bottom: 45px;

  ${media.desktop`
    height: 100%;
    width: calc(50% + 7.5px);
    min-height: unset;
  `}
  ${media.tablet`
    height: 50%;
    width: 100%;
  `}
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductCard.tsx